module.exports = __webpack_public_path__ + "img/loading.59efa3e8.svg";